export default function (saleOrderAccessToken, activity) {
  return `mutation logActivity {
    logActivity(saleOrderAccessToken: "${saleOrderAccessToken}", activity: "${activity}") {
      result
    }
  }`
}
